
import { useSearchParams } from "react-router-dom";
import ContactForm from "./contact/ContactForm";
import DemoForm from "./contact/DemoForm";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation('contact');
  const [searchParams] = useSearchParams();
  const formType = searchParams.get("type") || "contact";

  return (
    <div className="min-h-screen py-24 bg-gradient-to-br from-background to-muted/50">
      <div className="container-custom">
        <div className="relative max-w-2xl mx-auto">
          <div className="absolute inset-0 -z-10 bg-[radial-gradient(45rem_50rem_at_top,theme(colors.brand.orange/5),transparent)]" />
          <div className="absolute inset-0 -z-10 bg-[radial-gradient(45rem_50rem_at_bottom_right,theme(colors.brand.blue/5),transparent)]" />
          <h1 className="text-4xl font-bold text-center mb-2 bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-orange pb-2">
            {formType === "demo" ? t('title.demo') : t('title.contact')}
          </h1>
          <p className="text-center text-muted-foreground mb-12 text-lg">
            {formType === "demo" ? t('description.demo') : t('description.contact')}
          </p>
          <div className="bg-card/50 backdrop-blur-sm border border-border/50 rounded-2xl p-8 shadow-xl">
            {formType === "demo" ? <DemoForm /> : <ContactForm />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
